export enum AgreementTypes {
    DataConsent = 'DataConsent',
    GINAAgreement = 'GINAAgreement',
    MembershipAgreement = 'MembershipAgreement',
    PrivacyPolicy = 'PrivacyPolicy',
    SponsorAgreement1 = 'SponsorAgreement1',
    SponsorAgreement2 = 'SponsorAgreement2'
}
